import { Vue, Component, Ref, Prop } from 'vue-property-decorator'
import AlertBanner from '@/components/common/AlertBanner/alert-banner.vue'

@Component({
    components: {
        AlertBanner
    }
})
export default class ConceptsModalBreakdownsBasicForm extends Vue {
    @Ref() readonly conceptsModalBreakdownsBasicForm!: any

    @Prop(String) readonly actionTitle!: string

    show() {
        this.conceptsModalBreakdownsBasicForm.show()
    }

    hide() {
        this.conceptsModalBreakdownsBasicForm.hide()
    }
}
